import * as React from 'react';
import AssetsManager from '../../../../../../common/utils/AssetsManager';

class ValidationIdSuccessView extends React.Component<{}, {}> {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <React.Fragment>
                <div className="modal-info">
                    <div className="modal-scroll">
                        <div className="container text-center">
                            <img className="py-3" src={AssetsManager('/assets/images/common/success-icon.svg')}/>
                            <p>La identificación del solicitante ha sido procesada.</p>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default ValidationIdSuccessView;
